import { Card, Typography } from "antd";
import React from "react";

export default function ({ icon, title, stat, secondary }) {
  return (
    <Card
      style={{ width: "100%", maxWidth: 300 }}
      styles={{
        body: {
          width: "100%",
          display: "flex",
          flexDirection: "column",
          padding: 24,
          rowGap: 8,
        },
      }}
    >
      <Typography.Text type={"secondary"} style={{ fontSize: "1.1em" }}>
        {icon} <span style={{ marginLeft: 3 }}>{title}</span>
      </Typography.Text>
      <div>
        <Typography.Title level={3} style={{ margin: 0 }}>
          {stat}
        </Typography.Title>
      </div>
      <div>
        <Typography.Text style={{ fontSize: "0.9em" }} type="secondary">
          {secondary}
        </Typography.Text>
      </div>
    </Card>
  );
}
